import styled from "styled-components";
import { theme } from "..";
export const HeaderMenuItem = styled.div `
  float: left;
  color: #444;
  height: ${theme.header.lineHeight};
  line-height: ${theme.header.lineHeight};
  padding: 0 10px;
  min-width: ${theme.header.lineHeight};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  :hover {
    color: "#444";
    background: rgba(0, 0, 0, 0.05);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyTWVudUl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9IZWFkZXJNZW51SXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFFdkMsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLElBQUksQ0FBQztBQUUzQixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQTs7O1lBRzVCLEtBQUssQ0FBQyxNQUFNLENBQUMsVUFBVTtpQkFDbEIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxVQUFVOztlQUV6QixLQUFLLENBQUMsTUFBTSxDQUFDLFVBQVU7Ozs7Ozs7Ozs7OztDQVlyQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwic3R5bGVkLWNvbXBvbmVudHNcIjtcblxuaW1wb3J0IHsgdGhlbWUgfSBmcm9tIFwiLi5cIjtcblxuZXhwb3J0IGNvbnN0IEhlYWRlck1lbnVJdGVtID0gc3R5bGVkLmRpdmBcbiAgZmxvYXQ6IGxlZnQ7XG4gIGNvbG9yOiAjNDQ0O1xuICBoZWlnaHQ6ICR7dGhlbWUuaGVhZGVyLmxpbmVIZWlnaHR9O1xuICBsaW5lLWhlaWdodDogJHt0aGVtZS5oZWFkZXIubGluZUhlaWdodH07XG4gIHBhZGRpbmc6IDAgMTBweDtcbiAgbWluLXdpZHRoOiAke3RoZW1lLmhlYWRlci5saW5lSGVpZ2h0fTtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcblxuICBjdXJzb3I6IHBvaW50ZXI7XG5cbiAgOmhvdmVyIHtcbiAgICBjb2xvcjogXCIjNDQ0XCI7XG4gICAgYmFja2dyb3VuZDogcmdiYSgwLCAwLCAwLCAwLjA1KTtcbiAgfVxuYDtcbiJdfQ==